import "./eidAdha.css"
import eidAlAdha01 from "./assets/eidAlAdha01.png"

export default function EidAladha() {
    return (
        <div className="shapes">
            <div className="eid-al-adha">
                <img src={eidAlAdha01} alt="Eid Al Adha" />
            </div>
        </div>
    )

}